import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class MachineAPI {

    URI_V1 = "/v1/payment-terminal"

    createMachine = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    updateMachine = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    findAllMachine = async () => {
        return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    deleteMachine = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };


}
